import _ from 'lodash';
import { AirportLocationTypes } from '../../constants';

// Airport is the default on the backend, so only city codes (e.g. NYC) need type in the url
const encodeGeonameAirportObj = (geoname) =>
  _.omitBy(
    _.pick(geoname, ['airportCode', 'label', 'type']),
    (value, key) => key === 'type' && value !== AirportLocationTypes.CITY,
  );

export default encodeGeonameAirportObj;
